import { Box, Button, Card, Tab, Tabs } from '@mui/material';
import { useEffect, useState } from 'react';
import PageHeaderLayout from '../../../components/Layout/PageHeaderLayout';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';
import UploadImagePage from './Image/UploadImagePage';
import VideoPage from './Video/VideoPage';

const UploadMedia = () => {
  const navigate = useNavigate();
  const { tab } = useParams();
  const [tabValue, setTabValue] = useState('0');

  useEffect(() => {
    if (tab && ['0', '1'].includes(tab)) {
      setTabValue(tab);
    } else {
      setTabValue('0');
      navigate('/admin/media/upload/0');
    }
  }, [tab, navigate]);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
    navigate(`/admin/media/upload/${newValue}`);
  };

  return (
    <Box>
      <PageHeaderLayout headerTitle={'Upload Media'}>
        <Button variant='contained' onClick={() => navigate(-1)} sx={{ height: "30px", marginTop: "10px" }} startIcon={<ArrowBack />}>
          Back
        </Button>
      </PageHeaderLayout>
      <Card sx={{ minWidth: "100%", marginBottom: ".5%" }}>
        <Box sx={{ width: '100%' }}>
          <Tabs
            value={tabValue}
            onChange={handleChange}
            textColor="secondary"
            indicatorColor="secondary"
            aria-label="secondary tabs example"
            sx={{ p: 0, minHeight: '40px' }}
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab value="0" label="Image Upload" sx={{ minHeight: '40px', textTransform: 'capitalize' }} />
            <Tab value="1" label="Video Upload" sx={{ minHeight: '40px', textTransform: 'capitalize' }} />
          </Tabs>
        </Box>
      </Card>
      {tabValue === '0' && <UploadImagePage />}
      {tabValue === '1' && <VideoPage />}
    </Box>
  );
}

export default UploadMedia
